<template>
  <div class="assistant-screen-wrapper">
    <ChatHeader
      :assistant="AssistantType.LegalAssistant"
      :reset-conversation="
        !!legalAssistantRef ? legalAssistantRef.resetConversation : () => {}
      "
      :enable-new-conversation-button="true"
      :current-conversation-id="selectedConversationId"
      :show-history="showHistory"
    />
    <ChatComponent
      ref="legalAssistantRef"
      v-bind="legalAssistantProps"
      :selected-conversation-id="selectedConversationId"
      :use-streaming-response="useStreamingResponse"
    />
  </div>
</template>

<script setup lang="ts">
import ChatComponent from '@/components/common/chat/ChatComponent.vue';
import ChatHeader from '@/components/common/chat-header/ChatHeader.vue';
import { AssistantType } from '@/models/assistant-types';
import { useLegalAssistant } from '@/composables/useLegalAssistant';
import { computed, ref, ComputedRef } from 'vue';
import { useStreaming } from '@/composables/useStreaming';
import { useUserSettingsStore } from '@/stores/userSettingsStore';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { RagIndex } from '@/core/indexesEnum';

const { legalAssistantRef, legalAssistantProps } = useLegalAssistant();

const userSettingsStore = useUserSettingsStore();

const selectedRagIndex: ComputedRef<RagIndex | string | undefined> = computed(
  () => userSettingsStore.getSafeSelectedRagIndex()
);

const useStreamingResponse = useStreaming(selectedRagIndex);

const route = useRoute();
const authStore = useAuthStore();

const selectedConversationId = ref<string | undefined>(
  route.query.conversationId as string | undefined
);
const showHistory = ref(!authStore.IsConcurrentUser);
</script>

<style scoped lang="scss">
.assistant-screen-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.header-icons {
  display: flex;
  gap: $space-2;
}
</style>
